function cartReplaceNode(current, next) {
  if (current && next) {
    current.replaceWith(next);
  }
}

function getCartNoteElement() {
  return document.getElementById('CartSpecialInstructions');
}

function getCartNoteValue() {
  var noteEl = getCartNoteElement();
  return noteEl ? noteEl.value : '';
}

function persistCartNote(noteValue) {
  return fetch(theme.routes_cart_url + '/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ note: noteValue || '' })
  }).catch(function(err) {
    console.error('Cart note save failed:', err);
  });
}

function bindCartNote() {
  var noteEl = getCartNoteElement();
  if (!noteEl || noteEl.dataset.cartNoteBound === 'true') return;

  noteEl.dataset.cartNoteBound = 'true';
  var debounceTimer;

  noteEl.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      persistCartNote(noteEl.value);
    }, 500);
  });

  noteEl.addEventListener('blur', function() {
    clearTimeout(debounceTimer);
    persistCartNote(noteEl.value);
  });
}

function rebindCartTerms(container, chk) {
  if (chk !== 'true') return;

  var termsEl = document.getElementById('cart-terms');
  var checkoutBtn = container.querySelector('[name="checkout"]');
  var acb = container.querySelector('.bmw-additional-checkout') || container.querySelector('.additional-checkout-buttons');
  if (!termsEl || !checkoutBtn) return;

  termsEl.onchange = function() {
    if (this.checked) {
      checkoutBtn.classList.remove('outline');
      checkoutBtn.removeAttribute('disabled');
      checkoutBtn.setAttribute('aria-label', theme.language.cart_general_checkout);
      checkoutBtn.value = theme.language.cart_general_checkout;
      checkoutBtn.textContent = theme.language.cart_general_checkout;
      if (acb) acb.classList.remove('hidden');
    } else {
      checkoutBtn.classList.add('outline');
      checkoutBtn.setAttribute('disabled', true);
      checkoutBtn.setAttribute('aria-label', theme.language.cart_general_agree);
      checkoutBtn.value = theme.language.cart_general_agree;
      checkoutBtn.textContent = theme.language.cart_general_agree;
      if (acb) acb.classList.add('hidden');
    }
  };
}

function CartReload(data) {
  var container = document.getElementById('cart-table');
  if (!container) return;

  const parser = new DOMParser();
  const htmlDocument = parser.parseFromString(data, 'text/html');
  var doc = htmlDocument.documentElement;
  var section = container.closest('[data-section-type="cart_page"]');
  var chk = section ? section.getAttribute('data-check') : null;

  cartReplaceNode(
    document.getElementById('total-top'),
    doc.querySelector('#total-top')
  );
  cartReplaceNode(
    document.querySelector('.cart-table'),
    doc.querySelector('.cart-table')
  );
  cartReplaceNode(
    document.getElementById('total-bottom'),
    doc.querySelector('#total-bottom')
  );
  cartReplaceNode(
    document.querySelector('.bmw-cart-summary'),
    doc.querySelector('.bmw-cart-summary')
  );
  cartReplaceNode(
    document.querySelector('.bmw-cart-hero__count'),
    doc.querySelector('.bmw-cart-hero__count')
  );

  var fullForm = container.querySelector('.full-form');
  var emptyForm = container.querySelector('.empty-form');
  if (fullForm) fullForm.classList.remove('hidden');
  if (emptyForm) emptyForm.classList.add('hidden');

  document.querySelectorAll('.bmw-cart-item').forEach(function(el, i) {
    el.style.setProperty('--bmw-item-delay', (220 + i * 55) + 'ms');
  });

  bindCartNote();
  if (window.ToeeOrderAttachments) window.ToeeOrderAttachments.bindCart(document);
  // The vehicle line came back in the new .bmw-cart-summary hidden and empty; a picker anchored on the old one goes.
  window.ToeeVehicleChip && window.ToeeVehicleChip.closePicker();
  window.ToeeVehicleChip && window.ToeeVehicleChip.paintCartLine();
  rebindCartTerms(container, chk);
  Quantity(container);
  CartButtons();
}

function cartHideBusy() {
  var aB = document.getElementById('ajaxBusy');
  if (aB) aB.style.display = 'none';
}

function cartFormatMoney(cents) {
  return Shopify.formatMoney(cents, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
}

function CartChange(q, container) {
  var header = document.querySelector('header');
  var it = q.closest('.item');
  if (!it) return;

  var id = it.getAttribute('data-product-id');
  var qtyInput = it.querySelector('.item-qty');
  if (!qtyInput) return;

  var quantity = qtyInput.value;
  var rct = container.getAttribute('data-recent');
  var pendingNote = getCartNoteValue();
  var aB = document.getElementById('ajaxBusy');
  var cTa = document.getElementById('cart-table');
  var cC = document.querySelectorAll('.cartCountSelector');
  var cT = document.querySelector('.cartTotalSelector');
  var tT = document.getElementById('total-cart-top');
  var tC = document.getElementById('cart-total');
  var tB = document.getElementById('total-cart-bottom');
  var dC = document.querySelector('.discount-cart');
  var aS = document.querySelector('.animate-section');
  var cD = document.getElementById('cart-dropdown');

  if (quantity != '') {
    if (aB) aB.style.display = 'block';
  }

  fetch(theme.routes_cart_change_url + '.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ quantity: quantity, id: id })
  }).then(function(r) {
    return r.json();
  }).then(function(j) {
    if (quantity != '') {
      cC.forEach(function(el) {
        el.textContent = j.item_count;
      });
      if (header && cT) {
        cT.innerHTML = cartFormatMoney(j.total_price);
        if (tT) tT.innerHTML = cartFormatMoney(j.total_price);
      }
      if (j.cart_level_discount_applications && j.cart_level_discount_applications.length > 0) {
        if (tC) tC.innerHTML = cartFormatMoney(j.items_subtotal_price);
        if (dC) dC.innerHTML = cartFormatMoney('-' + j.total_discount);
      }
      if (tB) tB.innerHTML = cartFormatMoney(j.total_price);
    }

    if (j.item_count == 0) {
      ShippingMsg();
      if (cTa) {
        var fullForm = cTa.querySelector('.full-form');
        var emptyForm = cTa.querySelector('.empty-form');
        if (fullForm) fullForm.classList.add('hidden');
        if (emptyForm) emptyForm.classList.remove('hidden');
      }
      cartHideBusy();
      if (theme.dropdown == true) {
        var cartCountMobile = document.querySelector('.cart-count-mobile');
        if (cartCountMobile) {
          cartCountMobile.setAttribute('href', theme.routes_cart_nav_url || theme.routes_cart_url);
          cartCountMobile.classList.remove('void');
        }
      }
      if (cD) {
        cD.remove();
      }
      if (rct == 'true' && aS) {
        document.querySelector('.animate-section').classList.add('go', 'up');
      }
    } else {
      var x = theme.cart;
      CartDrop(x);
      persistCartNote(pendingNote).finally(function() {
        fetch(theme.routes_cart_url)
          .then(function(response) { return response.text(); })
          .then(function(data) {
            if (quantity != '') {
              if (quantity == 0) {
                it.remove();
              }
              try {
                CartReload(data);
              } catch (err) {
                console.error('CartReload: ' + err);
              }
            }
            cartHideBusy();
          }).catch(function(err) {
            console.error('!: ' + err);
            cartHideBusy();
          });
      });
    }
  }).catch(function(err) {
    console.error('!: ' + err);
    cartHideBusy();
  });
}

function CartButtons() {
  var container = document.getElementById('cart-table');
  if (!container) return;

  var qB = container.querySelectorAll('.qtybtn');
  qB.forEach(function(q) {
    var vM;
    var vV;
    if (q.classList.contains('icon-plus')) {
      var qF = q.closest('.quantity.form');
      if (qF) {
        var qtyEl = qF.querySelector('.item-qty');
        if (qtyEl) {
          vV = qtyEl.value;
          vM = qtyEl.getAttribute('max');
        }
      }
    }
    setTimeout(function() {
      q.onclick = function() {
        if (vM && vM == vV) {
          return;
        }
        CartChange(q, container);
      };
    }, 1);
  });

  var qI = container.querySelectorAll('.item-qty');
  qI.forEach(function(q) {
    var timeout;
    var vV = q.value;
    var vM = q.getAttribute('max');
    q.addEventListener('keyup', function(e) {
      if (e.key == 'Tab' || e.key == 'Shift') return;
      var nV = q.value;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        if (vM && nV == vV && vM == nV) {
          return;
        }
        CartChange(q, container);
      }, 750);
    });
  });
}

theme.CartPage = (function() {
  function CartPage(container) {
    var sectionId = container.getAttribute('data-section-id');
    var chk = container.getAttribute('data-check');
    var acb = container.querySelector('.bmw-additional-checkout') || container.querySelector('.additional-checkout-buttons');
    var rct = container.getAttribute('data-recent');
    var rV = document.getElementById('recently-viewed');
    var rVP = document.getElementById('recently-viewed-placeholder');
    theme.cart = true;
    document.querySelectorAll('.bmw-cart-item').forEach(function(el, i) {
      el.style.setProperty('--bmw-item-delay', (220 + i * 55) + 'ms');
    });
    Quantity(container);
    if (chk == 'true') {
      rebindCartTerms(container, chk);
    }
    bindCartNote();
    CartButtons(container);
    if (rct == 'true') {
      function gPD() {
        const pD = JSON.parse(localStorage.getItem('rVP'));
        const rVH = [];
        if (pD) {
          rV.classList.remove('hidden');
          pD.forEach(function(item) {
            rVH.push('id:' + item.pID);
          });
          const rB = rVH.join('%20OR%20');
          fetch(theme.routes_search_url + '?section_id=recently-viewed&q=' + rB + '&type=product')
            .then(function(response) { return response.text(); })
            .then(function(data) {
              const parser = new DOMParser();
              const htmlDocument = parser.parseFromString(data, 'text/html');
              var rVD = document.querySelector('.recently-viewed');
              var cP = htmlDocument.documentElement.querySelector('.collection-products');
              rVP.remove();
              rVD.appendChild(cP);
              if (theme.settings.quickView) {
                Quick();
              }
              if (theme.settings.compare) {
                CompareProducts();
              }
              Swatches(container);
              if (theme.settings.cart) {
                var sI = cP.getAttribute('data-section-id');
                Cart(container, sI);
              }
            }).catch(function(err) {
              console.log('!: ' + err);
            });
        }
      }
      gPD();
    }
    if (Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }
  return CartPage;
})();
